import script from "./UserMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserMenu.vue?vue&type=script&lang=ts&setup=true"

import "./UserMenu.vue?vue&type=style&index=0&id=31e0ce5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e0ce5c"]])

export default __exports__